import { TServices } from 'types/services';

import * as methods from './methods';

export const productionServices: TServices = methods;
